import { ajax } from '@/api/ajax';
import type { TCheckTopicValidReq, TCheckTopicValidRsp } from './type';

/**
 * 判断文章是否存在
 * */
export function checkTopicValid(data: TCheckTopicValidReq) {
  return ajax<TCheckTopicValidRsp>({
    url: '/api/node-server/xp-ass-tis-cn-boot/portal/repairInformation/checkTopicValid',
    method: 'post',
    data
  });
}
